import React from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { FORGOTTEN_PASSWORD } from 'config/url';

import Field from 'components/Field';
import Button from 'components/Button';

const SignIn = ({onSubmit}) => {
  const { handleSubmit, register, formState: { errors } } = useForm();
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Field label="Email" type="text"
        register={
          register("username", {
            required: true,
          })
        } />
      <Field label="Mot de passe" type="password"
        register={
          register("password", {
            required: true,
          })
        } />
      <div className="has-text-centered">
        <Button type="submit" className="is-primary">
          Se connecter
        </Button>
      </div>
      <div className="has-text-centered mt-5">
        <Link to={FORGOTTEN_PASSWORD}>
          Mot de passe oublié ?
        </Link>
      </div>
    </form>
  );
}

export default SignIn;